import type { Optional } from '@festina-life/core'

import type { ConfigurationFieldExpressionValue } from '../../types/templateModel'
import { FPlusDiff } from '../fplusDiff/FPlusDiff'
import { useHideInheritanceDiff } from './useHideInheritanceDiff'

type Props = {
  title: string
  current: Optional<ConfigurationFieldExpressionValue>
  compare: Optional<ConfigurationFieldExpressionValue>
}

export const ConfigurationFieldExpressionValueDiff = ({
  current,
  compare,
  title,
}: Props) => {
  const isHidingInheritanceDiff = useHideInheritanceDiff(current)

  if (isHidingInheritanceDiff) {
    return null
  }

  return (
    <FPlusDiff
      title={title}
      compare={compare?.expression?.fplusSource}
      current={current?.expression?.fplusSource}
    />
  )
}
